import React, { useState, useEffect } from 'react';
import FloatingCTA from '../components/FloatingCTA';
import './MiBit.css';

function MiBit() {
  const [currentImage, setCurrentImage] = useState(0);
  
  const productImages = [
    'https://customer-assets.emergentagent.com/job_e5c77d79-ca13-402d-b554-25dcc110651b/artifacts/mh3kjkgx_mbit%205301235914384281248_120.jpg',
    'https://customer-assets.emergentagent.com/job_e5c77d79-ca13-402d-b554-25dcc110651b/artifacts/j2ubg56j_mbit%205301235914384281249_120.jpg',
    'https://customer-assets.emergentagent.com/job_e5c77d79-ca13-402d-b554-25dcc110651b/artifacts/a4zohaqf_mbit%205301235914384281242_121.jpg',
    'https://customer-assets.emergentagent.com/job_e5c77d79-ca13-402d-b554-25dcc110651b/artifacts/95fvs6p9_mbit%205301235914384281250_121.jpg',
    'https://customer-assets.emergentagent.com/job_e5c77d79-ca13-402d-b554-25dcc110651b/artifacts/6f17jjca_mbit%205301235914384281251_121.jpg',
    'https://customer-assets.emergentagent.com/job_e5c77d79-ca13-402d-b554-25dcc110651b/artifacts/ynju4dnr_mbit%205301235914384281253_121.jpg',
    'https://customer-assets.emergentagent.com/job_e5c77d79-ca13-402d-b554-25dcc110651b/artifacts/j8x02u9d_mbit%205301235914384281252_121.jpg',
    'https://customer-assets.emergentagent.com/job_e5c77d79-ca13-402d-b554-25dcc110651b/artifacts/aikuta6t_mbit%205301235914384281243_121.jpg',
    'https://customer-assets.emergentagent.com/job_e5c77d79-ca13-402d-b554-25dcc110651b/artifacts/2wpttzg5_mbit%205301235914384281244_121.jpg',
    'https://customer-assets.emergentagent.com/job_e5c77d79-ca13-402d-b554-25dcc110651b/artifacts/9ltwxmhn_mbit%205301235914384281245_121.jpg',
    'https://customer-assets.emergentagent.com/job_e5c77d79-ca13-402d-b554-25dcc110651b/artifacts/tmdvd35b_mbit%205301235914384281246_120.jpg',
    'https://customer-assets.emergentagent.com/job_e5c77d79-ca13-402d-b554-25dcc110651b/artifacts/3t8q4z8s_mbit%205301235914384281247_120.jpg',
    'https://customer-assets.emergentagent.com/job_e5c77d79-ca13-402d-b554-25dcc110651b/artifacts/70sx80zr_mbit%205301235914384281254_121.jpg'
  ];

  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused) return;
    
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % productImages.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [isPaused]);

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % productImages.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + productImages.length) % productImages.length);
  };

  return (
    <div className="mibit-page" data-testid="mibit-page">
      <FloatingCTA />

      <section className="page-hero">
        <div className="container">
          <h1>MiBit</h1>
          <p className="hero-subtitle">Innovative Lösungen für strahlungsarme Technik, Datensouveränität und digitale Sicherheit</p>
        </div>
      </section>

      {/* YouTube Video Section */}
      <section className="intro-video-section section">
        <div className="container">
          <div className="youtube-wrapper">
            <iframe
              src="https://www.youtube.com/embed/_b5yT0F837s?start=3"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="youtube-video"
              title="MiBit Introduction"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="content-section section">
        <div className="container">
          <div className="content-wrapper">
            <div className="intro-block">
              <p>
                Moderne, strahlungsarme Geräte sind heute wichtiger denn je, da sie hohen Ansprüchen an Gesundheit und Sicherheit gerecht werden müssen. Diese Technologien schützen Nutzer durch reduzierte elektromagnetische Belastung (gen 0) und bieten gleichzeitig leistungsfähige Funktionen.
              </p>
              <p>
                Ein wesentlicher Fokus liegt auf der Wahrung uneingeschränkter Datensouveränität: Anwender behalten die volle Kontrolle über ihre persönlichen Daten und können so selbstbestimmt und geschützt handeln. Nachhaltigkeit, Datenschutz und intuitive Bedienung bilden die Grundlage für alle Entwicklungen.
              </p>
            </div>

            {/* Product Image Slider */}
            <div 
              className="product-slider"
              onMouseEnter={() => setIsPaused(true)}
              onMouseLeave={() => setIsPaused(false)}
            >
              <button className="slider-btn slider-btn-left" onClick={prevImage}>‹</button>
              <div className="slider-container">
                <img 
                  src={productImages[currentImage]}
                  alt={`MiBit Product ${currentImage + 1}`}
                  className="slider-image"
                />
                <div className="slider-indicators">
                  {productImages.map((_, index) => (
                    <button
                      key={index}
                      className={`slider-dot ${index === currentImage ? 'active' : ''}`}
                      onClick={() => setCurrentImage(index)}
                    />
                  ))}
                </div>
              </div>
              <button className="slider-btn slider-btn-right" onClick={nextImage}>›</button>
            </div>

            <div className="product-section">
              <p>
                Die Lösungen von MiBit im Bereich Handy, Laptop und Software vereinen innovative Technologien, die Sicherheit, Diskretion und digitale Unabhängigkeit fördern. Entwickelt für Menschen, die besonderen Wert auf Datenschutz und finanzielle Freiheit legen. Ergänzend bieten spezialisierte Softwarelösungen einen effektiven Schutz vor Überwachung und unbefugtem Zugriff. MiBits ganzheitliches Sicherheitskonzept integriert Hard- und Software nahtlos und gewährleistet dabei eine benutzerfreundliche Handhabung, damit Anwender maximale Kontrolle und Freiheit über ihre Daten behalten.
              </p>
              <p>
                Als Vorreiter verbindet MiBit modernste technische Ansätze mit einem ganzheitlichen Verständnis von Sicherheit und Gesundheit. Die Lösungen stehen für digitale Unabhängigkeit, maximale Freiheit und Kontrolle über Daten und Finanzen.
              </p>
              <p>
                Zukünftige Innovationen werden diesen Weg weiterhin vorantreiben und für noch mehr Sicherheit und Komfort sorgen. MiBit repräsentiert somit eine neue Generation verantwortungsvoller Technologien, die optimal auf die Bedürfnisse von Anwendern in einer zunehmend überwachten Welt zugeschnitten sind.
              </p>
            </div>

            <div className="award-section">
              <h2>Burj CEO Awards 2025</h2>
              <p className="award-intro">
                Neo (der Gründer von MiBit) wurde beim 8th Burj CEO Awards 2025 nicht nur nominiert, sondern hat den Award gewonnen!
              </p>
              <p>
                Diese Auszeichnung gilt als die „Oscars der Wirtschaft“ und ehrt nur echte, nachhaltige Innovationen und nachweisbare Spitzenleistungen. Die Nominierungen durchläuft ein strenges Prüfverfahren durch ein erfahrenes Gremium, das sicherstellt, dass nur Unternehmen mit realen Produkten und messbarem wirtschaftlichem und gesellschaftlichem Impact ausgezeichnet werden.
              </p>
              <p className="award-highlight">
                Der Gewinn bestätigt eindrucksvoll, dass Neo ein etabliertes, vertrauenswürdiges Unternehmen mit echten Zukunftslösungen ist.
              </p>
              <p>
                Seht selbst, wie hoch das Level und die Exzellenz sind, mit denen Neo jetzt international glänzt!
              </p>
              
              <div className="award-video">
                <video controls className="mibit-video">
                  <source src="https://customer-assets.emergentagent.com/job_e5c77d79-ca13-402d-b554-25dcc110651b/artifacts/lwyl2oo0_mibit%20award.mp4" type="video/mp4" />
                </video>
              </div>

              <div className="news-link-box">
                <h3>📰 Award News</h3>
                <p>Lesen Sie mehr über die Auszeichnung:</p>
                <a 
                  href="https://uaenews247.com/2025/11/26/burj-ceo-awards-2025-honours-global-leaders-innovators-and-entrepreneurs"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="news-link"
                >
                  🔗 Burj CEO Awards 2025 - News Artikel
                </a>
              </div>

              <div className="manufacturer-link-box">
                <h3>🏭 Hersteller-Seite</h3>
                <p>Besuchen Sie die offizielle MiBit Labs Website:</p>
                <a 
                  href="https://mibitlabs.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="manufacturer-link"
                >
                  🌐 https://mibitlabs.com/
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section section">
        <div className="container">
          <div className="cta-content">
            <h2>Bereit, den ersten Schritt zu machen?</h2>
            <p>Werde Teil unserer Gemeinschaft und starte deine Reise zur finanziellen Freiheit.</p>
            <div className="qr-code-container">
              <a 
                href="/#cta-section" 
                className="qr-code-link"
                data-testid="foerderer-cta-link"
              >
                Jetzt persönlichen Förderer finden →
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default MiBit;
